export const cart = {
    title: 'Cart',
    empty: 'Your cart is empty',
    emptyDescription: 'Add products to your cart to continue',
    continueShopping: 'Continue shopping',
    checkout: 'Contact seller',
    items: 'items',
    item: 'item',
    removeItem: 'Remove item',
    updateQuantity: 'Update quantity',
    decreaseQuantity: 'Decrease quantity',
    increaseQuantity: 'Increase quantity',
    close: 'Close cart',
    subtotal: 'Subtotal',
    shipping: 'Shipping',
    discount: 'Discount',
    total: 'Total',
    estimatedShipping: 'Estimated shipping',
    freeShipping: 'Free shipping',
    minForFreeShipping: '{{amount}} away from free shipping',
};
//# sourceMappingURL=cart.js.map